export const OTP_LENGTH = 6;
export const OTP_RESEND_TIMEOUT = 60;
export const ACCESS_TOKEN_KEY = 'ACCESS_TOKEN';
export const REFRESH_TOKEN_KEY = 'REFRESH_TOKEN';
export const DRAFT_CAMPAIGN_KEY = 'pathiq_draft_campaign';

// Admin auth constants
export const ADMIN_ACCESS_TOKEN_KEY = 'ADMIN_ACCESS_TOKEN';
export const ADMIN_REFRESH_TOKEN_KEY = 'ADMIN_REFRESH_TOKEN';

// Tenant staff auth constants
export const TENANT_STAFF_ACCESS_TOKEN_KEY = 'TENANT_STAFF_ACCESS_TOKEN';
